const booleanValue = (value) => value === true || value === "true";

export const isRecipeStockRateCard = (option = {}) =>
  booleanValue(option.holdStock)
  && Boolean(option.conversionType?.id || option.conversionType?.cnvId || option.conversionId);

export const getRecipeIngredientUnit = (value = {}) => {
  const conversion = value.conversionType || value;
  if (!conversion) return "";
  return booleanValue(conversion.unitRestrictions)
    ? (conversion.unitName || "")
    : (conversion.smallUnitName || conversion.unitName || "");
};

export const getRecipeIngredientLabel = (option = {}) => {
  if (option.stockName) return option.stockName;
  const productName = option.productName || option.name || "Unnamed ingredient";
  const rateCardName = option.rateCardName || option.foodQuantityName || "";
  return rateCardName ? `${productName} (${rateCardName})` : productName;
};

export const toRecipeIngredient = (option = {}) => ({
  stockId: option.id || option.stockId || "",
  conversionId: option.conversionType?.id || option.conversionType?.cnvId || option.conversionId || "",
  stockName: getRecipeIngredientLabel(option),
  unitName: getRecipeIngredientUnit(option),
  unitRestrictions: booleanValue(option.conversionType?.unitRestrictions ?? option.unitRestrictions),
  decimalSmRestrictions: booleanValue(
    option.conversionType?.decimalSmRestrictions ?? option.decimalSmRestrictions
  ),
});

export const isRecipeIngredientQuantityAllowed = (ingredient = {}, quantityValue) => {
  const quantity = Number(quantityValue);
  if (!Number.isFinite(quantity) || quantity <= 0) return false;
  return !booleanValue(ingredient.decimalSmRestrictions) || Number.isInteger(quantity);
};

export const getRecipeIngredientQuantityInput = (ingredient = {}) => {
  const wholeNumberOnly = booleanValue(ingredient.decimalSmRestrictions);
  return {
    min: wholeNumberOnly ? 1 : 0.001,
    step: wholeNumberOnly ? 1 : 0.001,
    inputMode: wholeNumberOnly ? "numeric" : "decimal",
  };
};
